import { render, staticRenderFns } from "./GuideBookPaperPageHeader.vue?vue&type=template&id=a08c1446"
import script from "./GuideBookPaperPageHeader.vue?vue&type=script&lang=js"
export * from "./GuideBookPaperPageHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports